import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import ErrorBoundary from './components/ErrorBoundary';
import SiteLayout from './components/SiteLayout';
import GenerateOffer from './pages/GenerateOffer';
import NotFound from './pages/NotFound';
import OrderCancel from './pages/OrderCancel';
import OrderPage from './pages/OrderPage';
import OrderStatus from './pages/OrderStatus';
import OrderSuccess from './pages/OrderSuccess';
import LegalContact from './pages/legal/LegalContact';
import LegalPrivacy from './pages/legal/LegalPrivacy';
import LegalRefunds from './pages/legal/LegalRefunds';
import LegalTerms from './pages/legal/LegalTerms';
import PreviewPage from './pages/PreviewPage';

function App() {
  return (
    <Router>
      <div className="App">
        <ErrorBoundary>
        <Routes>
          <Route path="/preview" element={<PreviewPage />} />
          <Route path="/" element={<SiteLayout><GenerateOffer /></SiteLayout>} />
          <Route path="/order" element={<SiteLayout><OrderPage /></SiteLayout>} />
          <Route path="/order/success" element={<SiteLayout><OrderSuccess /></SiteLayout>} />
          <Route path="/order/cancel" element={<SiteLayout><OrderCancel /></SiteLayout>} />
          <Route path="/order/:orderId/status" element={<SiteLayout><OrderStatus /></SiteLayout>} />

          <Route path="/legal/terms" element={<SiteLayout><LegalTerms /></SiteLayout>} />
          <Route path="/legal/privacy" element={<SiteLayout><LegalPrivacy /></SiteLayout>} />
          <Route path="/legal/refunds" element={<SiteLayout><LegalRefunds /></SiteLayout>} />
          <Route path="/legal/contact" element={<SiteLayout><LegalContact /></SiteLayout>} />

          <Route path="*" element={<SiteLayout><NotFound /></SiteLayout>} />
        </Routes>
        </ErrorBoundary>
      </div>
    </Router>
  );
}

export default App;
